export default __webpack_public_path__ + "static/media/Hoock_ImageCycle.8089aa08.gif";